
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.228 18.375a.76.76 0 00.938.553 25.594 25.594 0 0113.659 0 .76.76 0 00.938-.553l2.39-10.153a.75.75 0 00-1.031-.863l-4.744 2.11a.76.76 0 01-.966-.319l-2.756-4.969a.75.75 0 00-1.312 0l-2.756 4.97a.76.76 0 01-.966.318l-4.744-2.11a.75.75 0 00-1.031.863l2.381 10.153zM9 15.16a27.897 27.897 0 016 0","stroke":"#EDC843","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    